import { useState } from "react";
import { useAuth } from "../../../../context/AuthContext";

function CanChangePasswordPage() {
    const { changePassword } = useAuth();
    const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
    const [message, setMessage] = useState("");
    const [saving, setSaving] = useState(false);

    const update = (event) => setForm({ ...form, [event.target.name]: event.target.value });

    const submit = async (event) => {
        event.preventDefault();
        setMessage("");
        if (form.newPassword !== form.confirmPassword) {
            setMessage("New passwords do not match.");
            return;
        }
        setSaving(true);
        try {
            await changePassword({ currentPassword: form.currentPassword, newPassword: form.newPassword });
            setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
            setMessage("Password changed successfully.");
        } catch (error) {
            setMessage(error.message);
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="twm-right-section-panel site-bg-gray">
            <form onSubmit={submit}>
                <div className="panel panel-default">
                    <div className="panel-heading wt-panel-heading p-a20">
                        <h4 className="panel-tittle m-a0">Change Password</h4>
                    </div>
                    <div className="panel-body wt-panel-body p-a20">
                        {message && <div className="alert alert-info">{message}</div>}
                        <div className="row">
                            <PasswordField label="Current Password" name="currentPassword" value={form.currentPassword} onChange={update} />
                            <PasswordField label="New Password" name="newPassword" value={form.newPassword} onChange={update} />
                            <PasswordField label="Confirm New Password" name="confirmPassword" value={form.confirmPassword} onChange={update} />
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <button type="submit" className="site-button" disabled={saving}>{saving ? "Saving..." : "Save Changes"}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    )
}

function PasswordField({ label, name, value, onChange }) {
    return (
        <div className="col-lg-6 col-md-6">
            <div className="form-group">
                <label>{label}</label>
                <div className="ls-inputicon-box">
                    <input className="form-control wt-form-control" name={name} type="password" required minLength={6} value={value} onChange={onChange} />
                    <i className="fs-input-icon fa fa-asterisk" />
                </div>
            </div>
        </div>
    );
}

export default CanChangePasswordPage;
